import { createClient } from '@supabase/supabase-js';
import { clientTarget } from '@/shared/yourplace/directory';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables');
}

// yourplace yp-5: a business on a server of its own signs in there. The directory
// stored that place on this device at sign-in; everyone else gets the build's own
// address, with nothing asked of the network.
const target = clientTarget(supabaseUrl, supabaseAnonKey);

export const supabase = createClient(target.url, target.key, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});
